import { render } from "./TabletThankYou.vue?vue&type=template&id=52d3f9a0"
import script from "./TabletThankYou.vue?vue&type=script&lang=js"
export * from "./TabletThankYou.vue?vue&type=script&lang=js"

import exportComponent from "/home/api.muzea.ro/wp-content/themes/szmm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__